"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DEFAULT_SIZE = 'sm';
var Radio = {
    parts: ['container', 'control', 'label'],
    baseStyle: {},
    defaultProps: {
        size: DEFAULT_SIZE,
    },
    sizes: {
        sm: {
            control: {
                width: 4,
                height: 4,
            },
        },
        md: {
            control: {
                width: 5,
                height: 5,
            },
        },
        lg: {
            control: {
                width: 6,
                height: 6,
            },
        },
    },
    variants: {
        black: function (props) { return ({
            label: {
                fontSize: getFontSizeForSize(props.size),
            },
            control: {
                _checked: {
                    // By default, Chakra' uses :before to create the dot in the center
                    //    of a selected radio item, which gets off-center on chrome :(
                    // Our "black" variant hides this :before element, and uses border color
                    //    instead.
                    _before: {
                        display: 'none',
                    },
                    bgColor: 'white',
                    borderColor: 'black',
                    borderWidth: getBorderWidthForSize(props.size),
                    _hover: {
                        bgColor: 'white',
                        borderColor: 'black',
                    },
                },
                // Once we sync our theme colors with Figma, we should replace this with a
                //    reference to our color primitives
                _disabled: {
                    bgColor: '#d2d5da',
                    borderColor: '#d2d5da',
                },
            },
        }); },
    },
};
function getBorderWidthForSize(size) {
    if (size === void 0) { size = DEFAULT_SIZE; }
    if (size === 'md')
        return 6;
    if (size === 'lg')
        return 7;
    return 5;
}
function getFontSizeForSize(size) {
    if (size === void 0) { size = DEFAULT_SIZE; }
    if (size === 'md')
        return '14px';
    if (size === 'lg')
        return '16px';
    return '12px';
}
exports.default = Radio;
